import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function TestimonialsSection() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    text: t('testimonials', 't1'),
    author: 'Jasselin H.'
  }, {
    text: t('testimonials', 't2'),
    author: 'Ruth A.'
  }, {
    text: t('testimonials', 't3'),
    author: 'Hanna AX'
  }, {
    text: t('testimonials', 't4'),
    author: 'Valeria N.'
  }, {
    text: t('testimonials', 't5'),
    author: 'Leydy M.'
  }];
  return <section id="testimonios" className="pt-8 pb-16 bg-white" data-id="element-392">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-393">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-394">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-6" data-id="element-395">
            {t('testimonials', 'title')}
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-8" data-id="element-396"></div>

          <a href="https://share.google/RJVtH1PZ9mwju5Loc" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center space-x-2 bg-beige px-6 py-3 rounded-full border border-gold/30 hover:bg-gold/10 hover:border-gold/50 transition-all duration-300 group" data-id="element-397">
            <div className="flex text-gold" data-id="element-398">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-399" />)}
            </div>
            <span className="font-bold text-dark" data-id="element-400">
              {t('testimonials', 'google')}
            </span>
            <span className="text-dark/50" data-id="element-401">|</span>
            <span className="text-dark/80 group-hover:text-gold-dark transition-colors" data-id="element-402">
              {t('testimonials', 'verified')}
            </span>
          </a>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-403">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-beige-light p-8 rounded-sm border border-gold/10 ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-404">
              <div className="flex text-gold mb-4" data-id="element-405">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-406" />)}
              </div>
              <p className="text-dark/80 italic mb-6" data-id="element-407">"{testimonial.text}"</p>
              <p className="font-bold text-dark font-serif" data-id="element-408">
                — {testimonial.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}